module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4901090d1df378dc333fab656582c5b9.png";